import { FormNames } from '@youscience/commonapp-service-common';

export const minDate = new Date(1953, 0);
export const maxDate = new Date(2028, 11);
export const PDF_FILE_PREFIX = 'data:application/pdf;base64,';

export const NOT_YET_AVAILABLE_CARD_TOOLTIP: Record<string, string> = {
  [FormNames.OPTIONAL_REPORT]:
    "The optional, mid-year, and final report forms allow you to update colleges about a student's academic progress after submitting the initial school report form.",
  [FormNames.OPTIONAL_REPORT2]:
    'The optional report 2 allows you to update submitted reports or add new information for the student. It is not required but is available after submitting the initial optional report form.',
  [FormNames.MIDYEAR_REPORT]:
    "The optional, mid-year, and final report forms allow you to update colleges about a student's academic progress after submitting the initial school report form.",
  [FormNames.FINAL_REPORT]:
    "The optional, mid-year, and final report forms allow you to update colleges about a student's academic progress after submitting the initial school report form.",
};
